import { RootState } from "redux/rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.stressCheckDetails.loading;
export const selectErrorMessage = (state: RootState) =>
  state.stressCheckDetails.error;
export const stressCheckDetailsDataResponse = (state: RootState) =>
  state.stressCheckDetails.stressCheckDetailsResponse;
